import { Link } from "react-router-dom";

export const Navbar = () => (
  <header className="sticky top-0 z-50 backdrop-blur-2xl bg-[#050505]/70 border-b border-white/5">
    <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
      <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5">
        <img src="/logo.png" alt="HoodBank" className="w-9 h-9 rounded-lg object-contain" />
        <span className="font-heading font-bold text-lg tracking-tight">
          Hood<span className="text-[#00C805]">Bank</span>
        </span>
      </Link>
      <nav className="flex items-center gap-6 text-sm text-neutral-400">
        <a href="/#how" data-testid="nav-how" className="hover:text-white transition-colors duration-200 hidden sm:block">How it works</a>
        <a href="/#holders" data-testid="nav-holders" className="hover:text-white transition-colors duration-200 hidden sm:block">Holders</a>
        <a href="/#statement" data-testid="nav-statement" className="hover:text-white transition-colors duration-200 hidden sm:block">Statement</a>
        <Link
          to="/account"
          data-testid="nav-account"
          className="rounded-full bg-[#00C805] text-black font-semibold px-5 py-2 text-sm hover:bg-[#13D059] transition-colors duration-200"
        >
          My Account
        </Link>
      </nav>
    </div>
  </header>
);
